import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Challenge, ContentSettingV2 } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_CHALLENGE_CONTENT_BY_CONTENT_ID = 'get-challenge-content-by-content-id';

export const useGetPatientChallengeContentByContentId = (contentId: number) => {
  return usePermittedQuery<ContentSettingV2<Challenge>>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/challenge/patient-challenge-setting/${contentId}`,
    {
      headers: {
        Accept: 'application/vnd.ysh.api.v2+json',
      },
    },
    [GET_CHALLENGE_CONTENT_BY_CONTENT_ID],
    {
      enabled: typeof contentId === 'number' && contentId >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
